module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"no":{"title":"Sett ditt daglige mål","subtitle":"Hvor mange minutter vil du trene hjernen?","cancel":"Avbryt","save":"Lagre"},"en":{"title":"Set your daily goal","subtitle":"How many minutes do you want to train your brain?","cancel":"Cancel","save":"Save"}}')
  delete Component.options._Ctor
}
